/** Imports */
import superJson from 'superjson';
import {type AppRouter} from '@/server/api/root';
import {httpBatchLink, httpBatchStreamLink, splitLink} from '@trpc/client';


/** Constants */
const dashboardQueries = new Set([
    'reportingsOverview.list',
    'reportingsOverview.editorOptions',
    'socialGoals.dashboard',
    'organizationDashboard.overview',
    'organizationDashboard.topContent',
    'organizationDashboard.topPosts',
    'organizationDashboard.topComments',
    'quickViewDashboard.configuration',
    'quickViewDashboard.get',
    'news.list',
]);


/** Stream independent dashboard results without changing mutation transport. */
export function createDashboardTransportLink(options: {
    url: string;
    fetch?: typeof fetch;
}) {
    const transportOptions = {
        url: options.url,
        transformer: superJson,
        fetch: (url: RequestInfo | URL, init?: RequestInit) => (
            (options.fetch ?? fetch)(url, {...init, credentials: 'include'})
        ),
    };
    return splitLink<AppRouter>({
        condition: (operation) => (operation.type === 'query') && dashboardQueries.has(operation.path),
        true: httpBatchStreamLink<AppRouter>(transportOptions),
        false: httpBatchLink<AppRouter>(transportOptions),
    });
}
